import { GroundTripAssignedLog } from '@/api/apis/route';

type GroundTripLogProps = {
  log: GroundTripAssignedLog;
};

export const GroundTripLog = ({ log }: GroundTripLogProps) => {
  return (
    <div className="flex flex-col p-3 gap-1 rounded bg-base-90">
      <span className="text-s-m text-base-5">Ground trip assigned:</span>
      <span className="text-m-m text-base-5 break-all">{log.tripReference.tripNumber}</span>
    </div>
  );
};
